import { useState } from 'react';
import { CircularProgress, Alert } from '@mui/material';
import api from '../services/api';

export default function Cotización() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const [loading, setLoading] = useState(false); // Nuevo estado para el cargador
  const [alertMessage, setAlertMessage] = useState(''); // Nuevo estado para las alertas

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    await api.post('/api/cotizacion', formData);

    setAlertMessage('Cotización enviada exitosamente');
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: ''
    });

  } catch (error) {
    console.error(error);
    setAlertMessage('Hubo un error al enviar la cotización');
  } finally {
    setLoading(false);
  }
};



  return (
    <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container py-5">
        <div className="row g-5">
        <div className="col-lg-7">
            <div className="section-title position-relative pb-3 mb-5">
              <h5 className="fw-bold text-primary text-uppercase">
                Solicitar Cotización
              </h5>
              <h2 className="h1 mb-0">
                ¿Necesitas una cotización gratuita? No dudes en contactarnos
              </h2>
            </div>
            <div className="row gx-3">
              <div className="col-sm-6 wow zoomIn" data-wow-delay="0.2s">
                <h5 className="mb-4">
                  <i className="fa fa-reply text-primary me-3"></i>Respuesta en
                  24 horas
                </h5>
              </div>
              <div className="col-sm-6 wow zoomIn" data-wow-delay="0.4s">
                <h5 className="mb-4">
                  <i className="fa fa-phone-alt text-primary me-3"></i>Soporte
                  telefónico 24 horas
                </h5>
              </div>
            </div>
            <p className="mb-4">
              Nuestro equipo está aquí para apoyar a tu negocio con tiempos de
              respuesta rápidos y asesoramiento experto. Nos especializamos en
              soluciones IT personalizadas y estamos listos para ayudarte a
              lograr tus objetivos. ¡No dudes en contactarnos para obtener una
              cotización o más información!
            </p>

            <div
              className="d-flex align-items-center mt-2 wow zoomIn"
              data-wow-delay="0.6s"
            >
              <div
                className="bg-primary d-flex align-items-center justify-content-center rounded"
                style={{ width: "60px", height: "60px" }}
              >
                <i className="fab fa-whatsapp text-white "></i>
              </div>
              <div className="ps-4">
                <h5 className="mb-2">Envíanos un WhatsApp</h5>
                <h4 className="text-primary mb-0">
                  <a
                    href="https://wa.me/+541161361408"
                    target="_blank"
                    className="text-primary"
                  >
                    Enviar WhatsApp
                  </a>
                </h4>
              </div>
            </div>
            <div
              className="d-flex align-items-center mt-2 wow zoomIn"
              data-wow-delay="0.6s"
            >
              <div
                className="bg-primary d-flex align-items-center justify-content-center rounded"
                style={{ width: "60px", height: "60px" }}
              >
                <i className="fa fa-phone-alt text-white"></i>
              </div>
              <div className="ps-4">
                <h5 className="mb-2">Llámanos para hacer cualquier pregunta</h5>
                <h4 className="text-primary mb-0">
                  <a href="tel:+541161361408" className="text-primary">
                    +54 11 6136 1408
                  </a>
                </h4>
              </div>
            </div>

            <div
              className="d-flex align-items-center mt-2 wow zoomIn"
              data-wow-delay="0.6s"
            >
              <div
                className="bg-primary d-flex align-items-center justify-content-center rounded"
                style={{ width: "60px", height: "60px" }}
              >
                <i className="fa fa-envelope text-white"></i>
              </div>
              <div className="ps-4">
                <h5 className="mb-2">Envíanos un Email</h5>
                <h4 className="text-primary mb-0">
                  <a href="mailto:info@elaritech.com" className="text-primary">
                    info@elaritech.com
                  </a>
                </h4>
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div
              className="bg-primary rounded h-100 d-flex align-items-center p-5 wow zoomIn"
              data-wow-delay="0.9s"
            >
      

              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-xl-12">
                    <input
                      type="text"
                      className="form-control bg-light border-0"
                      placeholder="Tu Nombre"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      style={{ height: '55px' }}
                      required
                    />
                  </div>
                  <div className="col-12">
                    <input
                      type="email"
                      className="form-control bg-light border-0"
                      placeholder="Tu Correo Electrónico"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      style={{ height: '55px' }}
                      required
                    />
                  </div>
                  <div className="col-12">
                    <input
                      type="text"
                      className="form-control bg-light border-0"
                      placeholder="Teléfono"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      style={{ height: '55px' }}
                      required
                    />
                  </div>
                  <div className="col-12">
                    <select
                      className="form-select bg-light border-0"
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      style={{ height: '55px' }}
                    >
                      <option value="" disabled>Selecciona un Servicio</option>
                      <option value="Desarrollo web">Desarrollo web</option>
                      <option value="Desarrollo móvil">Desarrollo móvil</option>
                      <option value="Desarrollo tv">Desarrollo tv</option>
                    </select>
                  </div>
                  <div className="col-12">
                    <textarea
                      className="form-control bg-light border-0"
                      rows="3"
                      placeholder="Mensaje"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>
                  <div className="col-12">
                    <button
                      className="btn btn-dark w-100 py-3"
                      type="submit"
                      disabled={loading} // Desactivar el botón si está cargando
                    >
                      {loading ? (
                        <CircularProgress size={24} color="inherit" /> // Mostrar el cargador
                      ) : (
                        'Solicitar Cotización'
                      )}
                    </button>
                  </div>
                </div>
                <br />
                <div>

                    {alertMessage && (
                      <Alert
                      severity={alertMessage.includes('error') ? 'error' : 'success'}
                      onClose={() => setAlertMessage('')}
                      style={{ width: '100%', paddingtop: '20px' }}
                      >
                  {alertMessage}
                </Alert>
              )}
              </div>
              </form>
            </div>
                    {/* Si hay un mensaje de alerta, mostrarlo */}
          </div>
        </div>
      </div>
    </div>
  );
}
